import {
	Id,
	LaravelResponse,
	MultiChangeEvent,
	PagedMultiSelectField,
	PagedMultiSelectFieldProps,
	PagedSingleSelectField,
	PagedSingleSelectFieldProps,
	laravelSelectFetchConfig,
} from "@dgs/core";
import { FC } from "react";
import { userTenantService } from "../api/userTenantService";
import { TenantIndexResource } from "../types/tenant";

interface SelectProps {
	name: string;
	label: string;
	required?: boolean;
	clearable?: boolean;
	disabled?: boolean;
	idsToRemove?: Id[];
}

interface SingleSelectProps extends SelectProps {
	getLabel?: PagedSingleSelectFieldProps<TenantIndexResource, LaravelResponse<TenantIndexResource>>["getLabel"];
}

interface MultiSelectProps extends SelectProps {
	getLabel?: PagedMultiSelectFieldProps<TenantIndexResource, LaravelResponse<TenantIndexResource>>["getLabel"];
	onChange?: (e: MultiChangeEvent<TenantIndexResource>) => void;
}

const fetcher = (idsToRemove: Id[]) => (search: string, page: number) =>
	userTenantService.options(search, page).then((response) => ({
		meta: response.data.meta,
		data: response.data.data.filter(({ id }) => !idsToRemove.includes(id)),
	}));

export const UserTenantSingleSelect: FC<SingleSelectProps> = ({ idsToRemove = [], ...props }) => {
	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(
				[...userTenantService.optionsKey, ...idsToRemove.map(toString)],
				fetcher(idsToRemove),
			)}
		/>
	);
};

export const UserTenantMultiSelect: FC<MultiSelectProps> = ({ idsToRemove = [], ...props }) => {
	return (
		<PagedMultiSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(
				[...userTenantService.optionsKey, ...idsToRemove.map(toString)],
				fetcher(idsToRemove),
			)}
		/>
	);
};
